import React, { useEffect } from "react";
import "./App.css";


import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { fetchIpAddress } from "./controllers/API"

import LoginPage from "./components/LoginPage/LoginPage.js";
import ResetPassword from "./components/LoginPage/ResetPassword.js";

// import SubAdminList from './pages/Accounts/SubAdmin/List.js'
// import SubAdminAddEditData from './pages/Accounts/SubAdmin/AddEditData.js'

import Sidebar from "./components/SideBar/Sidebar.jsx";
import Dashboard from "./pages/DashBaord/Dashboard.jsx";

// import UserList from "./pages/Accounts/UserList/UserList.js";
// import UserListEditPage from "./pages/Accounts/UserList/UserListEditPage.js";

import AdminDashboardEditPage from "./pages/DashBaord/DashboardEditPage.js";


import  TermAndCondition  from "./pages/CMS/TermAndCondition.js/TermAndCondition.js";
import PrivacyPolicy from "./pages/CMS/PrivacyPolicy/PrivacyPolicy.js";
import GeneralData from "./pages/CMS/GeneralData/StoreDetailsForm.js";
import EmailTemplets from "./pages/CMS/EmailTempets/list.js";
import EmailTempletsAddEddit from "./pages/CMS/EmailTempets/AddEditPage.js";
import Tickerdata from "./pages/CMS/tickerdata/ticker.js";

import Speakers from "./pages/Speakers/SpeakerList.js";
import SpeakersAddEdit from "./pages/Speakers/addEditSpeaker.js";

import Trainings from "./pages/Trainings/TrainingsList.js";
import TrainingAddEdit from "./pages/Trainings/addEditTraining.js";

import Coupons from "./pages/Coupons/couponsList.js";
import CouponAddEdit from "./pages/Coupons/addEditCoupons.js";

import Payments from "./pages/Payments/paymentList.js";

import Orders from "./pages/Orders/orderList.js";
import OrdersDetails from "./pages/Orders/orderDetails.js";

import ContactList from "./pages/Forms/contactList.js";
import NewsletterList from "./pages/Forms/newsletterList.js";

import RatingAndReview from "./pages/Rating And Review/List.js"; ////

import { useUserStore } from "./lib/userStore.js";

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // const { fetchUserInfo } = useUserStore();

  const getIp = async () => {
    await fetchIpAddress();
  };

  useEffect(() => {
    const checkAuthentication = async () => {
      await getIp();
      const token = sessionStorage.getItem("TOKEN");

      if (!["/", "/login", "/reset-password"].includes(location?.pathname)) {
        if (!token) {
          navigate("/");
        } else {
          // fetchUserInfo();
        }
      }
    };

    checkAuthentication();
  }, [location, navigate]);


  return (
    <div className="App">
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/dashboard" element={ <Sidebar> <Dashboard /> </Sidebar> } />      

          
          {/* CMS */}
          <Route path="/cms/term-condition" element={<Sidebar> <TermAndCondition/> </Sidebar> } />
          <Route path="/cms/privacy-policy" element={ <Sidebar> <PrivacyPolicy/> </Sidebar> } />
          <Route path="/cms/general-data" element={ <Sidebar> {" "} <GeneralData />{" "} </Sidebar> } />
          <Route path="/cms/email-templates" element={ <Sidebar> {" "} <EmailTemplets />{" "} </Sidebar> } />
          <Route path="/cms/email-templates/addeditdata" element={ <Sidebar> {" "} <EmailTempletsAddEddit />{" "} </Sidebar> } />
          <Route path="/cms/ticker-data" element={<Sidebar><Tickerdata/></Sidebar>} />

          <Route path="/orders/list" element={<Sidebar><Orders/></Sidebar>} />
          <Route path="/orders/addeditdata" element={<Sidebar><OrdersDetails/></Sidebar>} />
          <Route path="/payments" element={<Sidebar><Payments/></Sidebar>} />

          <Route path="/form/contact" element={<Sidebar><ContactList/></Sidebar>} />
          <Route path="/form/newsletter" element={<Sidebar><NewsletterList/></Sidebar>} />

          {/* <Route path="/rating-review" element={ <Sidebar> <RatingAndReview /> </Sidebar> }  /> */}

          

          {/* <Route
            path="/profile"
            element={
              <Sidebar>
                <Profile />
              </Sidebar>
            }
          /> */}
          

          <Route path="/speakers/list" element={ <Sidebar> <Speakers/> </Sidebar> } />
          <Route path="/speakers/addeditdata" element={ <Sidebar> <SpeakersAddEdit /> </Sidebar> } />

          <Route path="/trainings/list" element={ <Sidebar> <Trainings/> </Sidebar> } />
          <Route path="/trainings/addeditdata" element={ <Sidebar> <TrainingAddEdit /> </Sidebar> } />

          <Route path="/coupons/list" element={ <Sidebar> <Coupons/> </Sidebar> } />
          <Route path="/coupons/addeditdata" element={ <Sidebar> <CouponAddEdit /> </Sidebar> } />

        </Routes>
      
    </div>
  );
};

export default App;
